import { IconInfoCircle, mapper } from '@maia/icons';
import { BillingUnitDto, CmsProductDetailsDto } from '@maia/shared';
import { BigPricingPill } from '../../../molecules/pricing-pill/big-pricing-pill';
import { cardStyles } from '../../../patterns/card';
import { Modal } from '../../../molecules/modal/modal';
import { TextButton } from '../../../atoms/textButton/text-button';
import { Typography } from '../../../atoms/typography/typography';
import { twMerge } from 'tailwind-merge';
import { ToggleButton } from '../../../forms/toggleButton/toggleButton';
import { ProductDetails } from './moreinfo-modal';

type CompositionCardProps = {
  readonly title: string;
  readonly price: number;
  readonly activities: Array<{
    readonly title: string;
    readonly icon: string;
  }>;
  readonly isActive: boolean;
  readonly onToggle: () => void;
  readonly moreInfo?: CmsProductDetailsDto;
  readonly billingUnit: BillingUnitDto;
};

export function CompositionCard(props: CompositionCardProps) {
  const {
    isActive,
    title,
    activities,
    onToggle,
    price,
    moreInfo,
    billingUnit,
  } = props;

  return (
    <div
      className={cardStyles({
        variant: isActive ? 'outlined' : 'elevated',
        className: twMerge(
          'flex flex-col gap-y-20 p-20 grow shrink-0',
          isActive && 'border-success300 border-2',
        ),
      })}
    >
      <Typography variant="display6" weight="semibold">
        {title}
      </Typography>
      <BigPricingPill
        size="md"
        price={price}
        withFromTag
        variant="ghost"
        billingUnit={billingUnit}
      />
      <ToggleButton isSelected={isActive} onPress={onToggle}>
        {isActive ? 'Geselecteerd' : 'Selecteer'}
      </ToggleButton>
      <Modal
        content={
          moreInfo ? (
            <div className="flex flex-col overflow-auto">
              <ProductDetails elements={moreInfo.elements} />
            </div>
          ) : undefined
        }
        triggerSlot={
          <TextButton iconLeft={IconInfoCircle} className="underline">
            Wat wordt er verzekerd?
          </TextButton>
        }
      />
      <div>
        <Typography
          variant="body-s"
          weight="regular"
          className="inline-block text-grayscale400 mb-12"
        >
          Dit pakket bevat:
        </Typography>
        <ul className="flex flex-col gap-y-2 grow">
          {activities.map((activity) => (
            <li key={activity.title} className="flex items-center gap-x-8">
              {mapper(activity.icon)}
              <Typography variant="body-s" weight="medium">
                {activity.title}
              </Typography>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
